var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrayCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 21,
    fill: "#F4F8FC",
    stroke: "#A2B1CE",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4828 28.129C31.1724 28.767 31.1724 29.8835 30.4828 30.5215C30.1646 30.8405 29.7402 31 29.3159 31C28.8385 31 28.4142 30.8405 28.0959 30.5215L22.5265 24.939L16.9041 30.5215C16.5858 30.8405 16.1615 31 15.7371 31C15.2598 31 14.8354 30.8405 14.5172 30.5215C13.8276 29.8835 13.8276 28.767 14.5172 28.129L20.0866 22.4934L14.5172 16.9109C13.8276 16.2729 13.8276 15.1564 14.5172 14.5184C15.1537 13.8272 16.2676 13.8272 16.9041 14.5184L22.5265 20.1009L28.0959 14.5184C28.7324 13.8272 29.8463 13.8272 30.4828 14.5184C31.1724 15.1564 31.1724 16.2729 30.4828 16.9109L24.9134 22.5465L30.4828 28.129Z",
    fill: "#A2B1CE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCross);
export default __webpack_public_path__ + "static/media/gray-cross.d2eca742af00b080138e6c17b40f0c49.svg";
export { ForwardRef as ReactComponent };